import React from 'react';
import { findEmailConfirmationFor, findPaymentFrequencyFor } from "../../enums/BenefitType";
import { PaymentFrequency } from "../../enums/PaymentFrequency";
import Summary from "../../common/Summary";
import { useFormikContext } from "formik";
import { FormValues } from "../../common/FormValues";

const EmployeeSummary = () => {
    const { values } = useFormikContext<FormValues>()
    const benefit = values.benefit

    const nextSteps = [findEmailConfirmationFor(benefit), "If we need any additional information, we'll contact you by email."];
    const includePaymentsNextStep = PaymentFrequency.RECURRING === findPaymentFrequencyFor(values.benefit);
    if(includePaymentsNextStep) {
        nextSteps.push('If your request is approved, the payments are typically paid weekly.');
    }
    return (<Summary ownsClaim={true} nextSteps={nextSteps}/>)
};

export default EmployeeSummary;
